import React from 'react';

//import Scss
import "assets/scss/themes.scss";
import 'remixicon/fonts/remixicon.css'
import './App.css'

//imoprt Route
import Route from 'Routes/Index';

// import fakeBackend from "./helpers/AuthType/fakeBackend";

// fakeBackend();

const App = () => {

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;